import { actionCreator } from '@ardoq/rxbeach';
import { ReportPageAndPagination, ReportSort } from '@ardoq/report-reader';
import {
  ArdoqId,
  FilterExpression,
  GraphlakeSnapshotId,
  PersonalSetting,
} from '@ardoq/api-types';
import { CopyReportUrLParams, ExportReportParams } from '../types';

export const excelExportFailed = actionCreator<boolean>(
  '[reportReader] SET_HAS_REPORT_EXCEL_EXPORT_FAILED'
);

export const pageAndPaginationChanged = actionCreator<ReportPageAndPagination>(
  '[reportReader] PAGE_AND_PAGINATION_CHANGED'
);

export const allFiltersCleared = actionCreator(
  '[reportReader] ALL_FILTERS_CLEARED'
);

export const drilldownWasTriggered = actionCreator<boolean>(
  '[reportReader] DRILLDOWN_WAS_TRIGGERED'
);

export const sortingChanged = actionCreator<ReportSort>(
  '[reportReader] SORTING_CHANGED'
);

export type FilterValueChangedPayload = {
  columnKey: ArdoqId;
  expression: FilterExpression[] | FilterExpression | null; // null when just added a new expression to the ui
};
export const filterValueChanged = actionCreator<FilterValueChangedPayload>(
  '[reportReader] FILTER_VALUE_CHANGED'
);

export const filterValueRemoved = actionCreator<ArdoqId>(
  '[reportReader] FILTER_VALUE_REMOVED'
);

/** null selects the latest data (no snapshot) */
export const snapshotSelected = actionCreator<GraphlakeSnapshotId | null>(
  '[reportReader] SNAPSHOT_SELECTED'
);

export const aggregatesWasTriggered = actionCreator<boolean>(
  '[reportReader] AGGREGATES_WAS_TRIGGERED'
);

export const exportToExcelButtonWasClicked = actionCreator<ExportReportParams>(
  '[report] EXPORT_TO_EXCEL_REQUESTED'
);

export const exportToReadableExcelButtonWasClicked =
  actionCreator<ExportReportParams>(
    '[report] EXPORT_TO_READABLE_EXCEL_REQUESTED'
  );

export const copyReportUrlWithStateIdButtonWasClicked =
  actionCreator<CopyReportUrLParams>('[report] COPY_REPORT_URL_WAS_REQUESTED');

export const forceReportRefresh = actionCreator(
  '[reportReader] FORCE_REPORT_REFRESH'
);

export const reportReaderNewFeatureNotificationClosed =
  actionCreator<PersonalSetting>(
    '[reportReader] NEW_FEATURE_NOTIFICATION_CLOSED'
  );
